import getGuestSchedulesPass from './getGuestSchedulesPass';
import getGuestSchedulesPassCount from './getGuestSchedulesPassCount';
import getScheduleGuestsCount from './getScheduleGuestsCount';
import searchGuests from './searchGuests';
import getGeneralReport from './getGeneralReport';

export default {
  getGuestSchedulesPass,
  getGuestSchedulesPassCount,
  getScheduleGuestsCount,
  searchGuests,
  getGeneralReport,
};
